import { useState } from 'react';
import PropTypes from 'prop-types';

import services from 'services';
import { VideoUrl } from '../video-url/video-url';
import { Videos, Container, Main, Selector, Refresh, Save } from './video-block-urls.styled';

let working = false;

export { Refresh, Save };

/**
 * refresh video url
 */
const refreshUrl = (url, createtime) => {
  if (url.includes('%3F') || url.includes('%26')) {
    return (url += (url.includes('%3F') ? '%26' : '%3F') + 'ct=' + createtime);
  }
  return (url += (url.includes('?') ? '&' : '?') + 'ct=' + createtime);
};

export const VideoBlockUrls = (props) => {
  const { rackId, camHeight = '310px', createtime = 0, cams = [], realVideo = false } = props;

  // find def cam
  const find = (idx) => {
    if (!cams || !cams[0]) {
      return null;
    }
    return cams.find((el) => {
      return el.id === idx;
    });
  };

  let defaultCam = services.getDefaultCam(rackId);
  if (!find(defaultCam)) {
    defaultCam = cams[0]?.id;
  }

  const [activeCam, setActiveCam] = useState(defaultCam);

  /**
   * get class name
   */
  const getClassName = (active) => {
    return active ? 'active' : 'inactive';
  };

  /**
   * set active cam
   * @param {*} cam
   */
  const changeActiveCam = (cam) => {
    services.setDefaultCam(rackId, cam);
    setActiveCam(cam);
  };

  /**
   * get videos
   */
  const getVideos = () => {
    return cams.map((cam) => {
      return getVideo(cam.id);
    });
  };

  /**
   * nope
   */
  const nope = () => {};

  /**
   * get video
   * @param {*} id
   * @param {*} main
   * @returns
   */
  const getVideo = (id, main = false) => {
    const cl = getClassName(activeCam === id);
    const cam = find(id);
    if (!cam) {
      console.error('🚀 ~ VideoBlockUrls not found', id);
    }
    const key = id + (main ? '_main' : '');
    const id1 = rackId + '_' + key;
    const url = refreshUrl(cam.url, createtime); // + (cam.url.includes('?') ? '&' : '?') + 'ct=' + createtime;
    // console.log('cam', cam, url);

    return <VideoUrl key={id1} id={id} id1={id1} createtime={createtime} className={cl} src={url} realVideo={realVideo} func={main ? nope : changeActiveCam} />;
  };

  /**
   * get active cam id
   * @returns
   */
  const getActiveCamId = () => {
    return rackId + '_' + activeCam + '_main';
  };

  /**
   * save shot from video stream
   * @returns
   */
  const save = () => {
    if (working) {
      return;
    }
    working = true;
    let camId = getActiveCamId();
    const c = document.createElement('canvas');
    const img = document.getElementById(camId);
    try {
      const w = img.width;
      const h = img.height;
      c.width = w;
      c.height = h;
      const ctx = c.getContext('2d');
      ctx.drawImage(img, 0, 0, w, h);
      const dataURL = c.toDataURL('image/png');
      const link = document.createElement('a');
      link.download = camId + '.png';
      link.href = dataURL;
      document.body.appendChild(link);
      link.dispatchEvent(
        new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
        }),
      );
      document.body.removeChild(link);
    } catch (e) {
      console.log('🚀 save image error', e);
    }
    working = false;
  };

  if (!cams || !cams[0]) {
    return null;
  }

  const video = getVideo(activeCam, true);
  const videos = cams.length > 1 ? getVideos() : null;
  return (
    <Videos>
      <Container height={camHeight}>
        <Save onClick={save} />
        <Main>{video}</Main>
        {cams.length > 1 && <Selector>{videos}</Selector>}
      </Container>
    </Videos>
  );
};

VideoBlockUrls.propTypes = {
  rackId: PropTypes.string.isRequired,
  camHeight: PropTypes.string.isRequired,
  createtime: PropTypes.number.isRequired,
  cams: PropTypes.array.isRequired,
};
